// extracted by mini-css-extract-plugin
export default {"activePowerTable":"PVPower_activePowerTable__-MKQn"};